module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.7@core-js/library/modules/_iter-step.js
// module id = 75
// module chunks = 0 1